module.exports = __webpack_public_path__ + "static/media/floor_load.551fc99a.svg";